import ModalImport from 'Features/Modal/ModalImport';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {ProModalProps} from 'Components/ProModal';
import {downloadTemplate, importOfficialAccount} from '../../service';

const Index = ({...props}: ProModalProps) => {
    const [onUpload] = useRequestFn(async file => {
        await importOfficialAccount(file);
        props.onOk?.();
    });

    return (
        <ModalImport
            {...props}
            title="公众号导入"
            onUpload={onUpload}
            ajaxDownloadFun={downloadTemplate}
            templateName="导入公众号模板"
            restSteps={<div>2.&nbsp;在导入模板补充好用户数据后上传文件</div>}
        />
    );
};

export default Index;
